export default { 
  GuideView: require('./GuideView').default,

}